import { configureStore } from "@reduxjs/toolkit";

import rootReducer from "store/rootReducer";

const store = configureStore({
  reducer: rootReducer,
});

if (import.meta.hot) {
  import.meta.hot.accept("store/rootReducer", (newModule) => {
    store.replaceReducer(newModule.default);
  });
}

export default store;
